const createElement = (opt = null) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  if (opt) {
    Object.keys(opt).forEach(key => {
      script[key] = opt[key];
    });
  }
  return script;
};

const injectScripUrl = (scriptUrl = '', opt) => {
  if (!scriptUrl) {
    console.warn('you need to pass the script url!!!');
    return false;
  }
  const elem = createElement(opt);
  elem.async = true;
  elem.src = scriptUrl;
  document.body.appendChild(elem);
  const promise = new Promise(resolve => {
    elem.onload = () => {
      resolve({
        loaded: true,
      });
    };
  });
  return promise;
};

const injectScriptSrc = (scriptSrc = '', opt) => {
  if (!scriptSrc) {
    console.warn('you need to pass the script source!!!');
    return false;
  }
  const elem = createElement(opt);
  elem.text = scriptSrc;
  document.body.appendChild(elem);
  return Promise.resolve({ loaded: true });
};

// eslint-disable-next-line import/prefer-default-export
export function inject(scriptUrl, scriptSrc, opt) {
  if (!scriptUrl && !scriptSrc) {
    console.warn('please pass a script url or src');
  }
  return scriptUrl ? injectScripUrl(scriptUrl, opt) : injectScriptSrc(scriptSrc, opt);
}
